<template>
  <v-card outlined>
    <v-card-title class="d-flex justify-space-between">
      <span>{{ itemSelecionado.usuarioAlteracao }}</span>
      <span>{{ functions.converterDateTimeStringEmLocaleDateTimeString(itemSelecionado.dataCadastro) }}</span>
    </v-card-title>

    <v-divider></v-divider>

    <v-expand-transition>
      <v-progress-linear
        v-show="isGetHistoricoLoading"
        indeterminate
      />
    </v-expand-transition>

    <v-expand-transition>
      <v-list v-show="algoFoiAlterado">
        <alteracoes-list-group
          v-if="tipoDeSolicitacaoFoiAlterado"
          list-item-title="Tipo de Solicitação"
          :pairs-of-values="paresDeValoresTipoDeSolicitacao"
        />
        <alteracoes-list-group
          v-if="statusFoiAlterado"
          list-item-title="Status"
          :pairs-of-values="paresDeValoresStatus"
        />
        <alteracoes-list-group
          v-if="integranteFoiAlterado"
          list-item-title="Integrante"
          :pairs-of-values="paresDeValoresIntegrante"
        />
        <alteracoes-list-group
          v-if="secaoClienteFoiAlterada"
          list-item-title="Seção Cliente"
          :pairs-of-values="paresDeValoresSecaoCliente"
        />
        <alteracoes-list-group
          v-if="respostasForamAlteradas"
          list-item-title="Respostas formulários"
          :pairs-of-values="paresDeValoresRespostasAtuaisEAnteriores"
        />
      </v-list>
    </v-expand-transition>
  </v-card>
</template>

<script>
import { mdiAccountCircle, mdiSort } from '@mdi/js'
import { computed, ref, watchEffect } from '@vue/composition-api'
import { converterDateTimeStringEmLocaleDateTimeString } from '@/utils/dateTime'
import { useTipoDeSolicitacaoAlteracoes, useStatusAlteracoes, useIntegranteAlteracoes } from './useTicketAlteracoes'
import useSecaoClienteAlteracoes from './useSecaoClienteAlteracoes'
import useFormulariosRespostasAlteracoes from './useFormulariosRespostasAlteracoes'
import AlteracoesListGroup from './AlteracoesListGroup.vue'

export default {
  components: {
    AlteracoesListGroup,
  },

  props: {
    itemSelecionado: {
      type: Object,
      required: true,
    },
    historico: {
      type: Object,
      required: true,
    },
    isGetHistoricoLoading: {
      type: Boolean,
      required: true,
    },
  },

  setup(props) {
    const historicoLocale = ref({})
    watchEffect(() => {
      historicoLocale.value = props.historico
    })

    const { tipoDeSolicitacaoFoiAlterado, paresDeValoresTipoDeSolicitacao } = useTipoDeSolicitacaoAlteracoes(historicoLocale)
    const { statusFoiAlterado, paresDeValoresStatus } = useStatusAlteracoes(historicoLocale)
    const { integranteFoiAlterado, paresDeValoresIntegrante } = useIntegranteAlteracoes(historicoLocale)
    const { secaoClienteFoiAlterada, paresDeValoresSecaoCliente } = useSecaoClienteAlteracoes(historicoLocale)
    const { respostasForamAlteradas, paresDeValoresRespostasAtuaisEAnteriores } = useFormulariosRespostasAlteracoes(historicoLocale)

    const algoFoiAlterado = computed(
      () => tipoDeSolicitacaoFoiAlterado.value
        || statusFoiAlterado.value
        || integranteFoiAlterado.value
        || secaoClienteFoiAlterada.value
        || respostasForamAlteradas.value,
    )
    return {
      tipoDeSolicitacaoFoiAlterado,
      paresDeValoresTipoDeSolicitacao,
      statusFoiAlterado,
      paresDeValoresStatus,
      integranteFoiAlterado,
      paresDeValoresIntegrante,
      secaoClienteFoiAlterada,
      paresDeValoresSecaoCliente,
      respostasForamAlteradas,
      paresDeValoresRespostasAtuaisEAnteriores,
      algoFoiAlterado,
      icons: {
        mdiAccountCircle,
        mdiSort,
      },
      functions: {
        converterDateTimeStringEmLocaleDateTimeString,
      },
    }
  },
}
</script>
